"use client";

import { c as _c } from "react/compiler-runtime";
import type { QueryStatus } from "@tanstack/react-query";
import type { ApiWave } from "@/generated/models/ApiWave";
import UserPageBrainSidebarWaveItem from "./UserPageBrainSidebarWaveItem";
interface UserPageBrainSidebarMostActiveProps {
  readonly waves: ApiWave[];
  readonly status: QueryStatus;
}
export default function UserPageBrainSidebarMostActive(t0) {
  const $ = _c(6);
  const {
    waves,
    status
  } = t0;
  const shouldShowLoading = status === "pending" && waves.length === 0;
  const shouldShowWaves = waves.length > 0;
  if (!shouldShowLoading && !shouldShowWaves) {
    return null;
  }
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span id="brain-most-active-waves-heading" className="tw-mb-3 tw-block tw-text-xs tw-font-semibold tw-uppercase tw-tracking-wider tw-text-iron-500">Most Active In</span>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== shouldShowLoading || $[2] !== waves) {
    t2 = shouldShowLoading ? <div className="tw-space-y-2.5" aria-label="Loading most active waves">{[0, 1, 2].map(_temp)}</div> : waves.map(_temp2);
    $[1] = shouldShowLoading;
    $[2] = waves;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t2) {
    t3 = <section aria-labelledby="brain-most-active-waves-heading">{t1}<div className="tw-space-y-2.5">{t2}</div></section>;
    $[4] = t2;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
}
function _temp2(wave) {
  return <UserPageBrainSidebarWaveItem key={wave.id} wave={wave} />;
}
function _temp(key) {
  return <div key={key} className="tw-flex tw-items-center tw-gap-3 tw-rounded-xl tw-border tw-border-solid tw-border-white/5 tw-bg-white/5 tw-p-3 tw-shadow-inner"><div className="tw-h-10 tw-w-10 tw-shrink-0 tw-animate-pulse tw-rounded-full tw-bg-white/[0.06]" /><div className="tw-min-w-0 tw-flex-1 tw-space-y-1.5"><div className="tw-h-3 tw-w-2/3 tw-animate-pulse tw-rounded tw-bg-white/[0.06]" /><div className="tw-h-2.5 tw-w-1/2 tw-animate-pulse tw-rounded tw-bg-white/[0.05]" /></div></div>;
}